import { Reveal, Overline } from "@/components/motion";

const Section = ({ title, children }) => (
  <div className="border border-noir-border bg-noir-surface p-7">
    <h2 className="font-display uppercase text-2xl tracking-wide text-gold">{title}</h2>
    <div className="mt-3 text-white/55 text-sm leading-relaxed">{children}</div>
  </div>
);

const LegalPage = ({ testId, overline, title, intro, sections }) => (
  <div data-testid={testId} className="px-6 md:px-12 lg:px-24 pt-40 pb-24 md:pb-32 min-h-screen">
    <Reveal>
      <Overline>{overline}</Overline>
      <h1 className="mt-4 font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight">
        {title}
      </h1>
      <p className="mt-6 max-w-2xl text-white/60 leading-relaxed">{intro}</p>
    </Reveal>
    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl">
      {sections.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.06} y={24}>
          <Section title={s.title}>{s.body}</Section>
        </Reveal>
      ))}
    </div>
  </div>
);

export const MentionsLegales = () => (
  <LegalPage
    testId="mentions-legales-page"
    overline="Informations légales"
    title="Mentions légales"
    intro="Cette page présente la structure des mentions légales du site 3M Match Pro. Les informations officielles de la société seront publiées ici dès qu'elles seront communiquées — aucune donnée n'a été inventée."
    sections={[
      { title: "Éditeur du site", body: "Raison sociale, forme juridique, capital, siège social et représentant légal : informations à compléter par 3M Match Pro." },
      { title: "Directeur de la publication", body: "Nom du directeur de la publication : à compléter." },
      { title: "Hébergement", body: "Coordonnées de l'hébergeur du site : à compléter lors de la mise en ligne officielle." },
      { title: "Propriété intellectuelle", body: "L'ensemble des contenus du site (textes, visuels, identité graphique) est protégé. Toute reproduction sans autorisation est interdite." },
    ]}
  />
);

export const PolitiqueConfidentialite = () => (
  <LegalPage
    testId="politique-confidentialite-page"
    overline="Vos données"
    title="Politique de confidentialité"
    intro="Cette page décrit le cadre de protection des données personnelles du site. La version officielle, conforme au RGPD, sera rédigée avec les informations de 3M Match Pro avant la collecte réelle de données."
    sections={[
      { title: "Données collectées", body: "À ce stade, seul le formulaire de contact enregistre les informations que vous transmettez volontairement (nom, prénom, email, téléphone, message)." },
      { title: "Données sensibles", body: "Les futures données d'inscription (dont les informations médicales des stagiaires) seront strictement privées, sécurisées et jamais exposées publiquement." },
      { title: "Vos droits", body: "Conformément au RGPD, vous disposerez d'un droit d'accès, de rectification et de suppression de vos données. Contact dédié : à compléter." },
      { title: "Cookies", body: "La gestion détaillée des cookies (bandeau de consentement) sera mise en place lors d'une phase ultérieure." },
    ]}
  />
);
